import './index.scss';
import { Spin } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import DoctorReportsStore from './DoctorReportsStore';
import ViewHistoryReport from './ViewHistoryReport';
import DoctorReportModal from './DoctorReportModal';
import DoctorRemittance from '../DoctorRemittance';
import Toolbar from './Toolbar';
import ExportToolbar from './ExportToolbar';

@observer
class DoctorReports extends React.Component {
  componentDidMount() {
    DoctorReportsStore.fetchDoctor(true);
  }

  render() {
    const {
      loadingDoctor,
      dataDoctor,
      loadingDoctorReports,
      dataDoctorReports,
      keyword,
      open,
      tabIsActive,
    } = DoctorReportsStore;

    return (
      <div
        className={`Table-${
          loadingDoctor && !dataDoctor ? 'loading' : 'container'
        }`}
      >
        {(!dataDoctor && loadingDoctor) ||
        (!dataDoctorReports && loadingDoctorReports && keyword) ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <Toolbar />
            {open && <DoctorReportModal />}
            {tabIsActive === 'historyReport' && <ViewHistoryReport />}
            {tabIsActive === 'remittanceStatements' && <DoctorRemittance />}
            {tabIsActive === 'export' && <ExportToolbar />}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default DoctorReports;
